import FormControl from "@material-ui/core/FormControl";
import MenuItem from "@material-ui/core/MenuItem";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import Select from "@material-ui/core/Select";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { bindActionCreators } from "redux";
import { userFarmDetail } from "../../../config/farmDetails";
import DropdownOptions from "../../../constants/DropdownOptions";
import {
  getHarvestYear,
  updateHarvestYear
} from "../../../modules/harvestYearManagement/action";
import {
  getPreferences,
  putPreferences
} from "../../../modules/preferences/action";
import { isAuthorized, isSuperAdmin } from "../../Common/CheckAuthorization";
import Dropdown from "../../FormElement/Dropdown";
import { Redirect } from "react-router-dom";
import color from "@material-ui/core/colors/amber";

const styles = theme => ({
  buttonText: {
    "& fieldset": {
      borderColor: "transparent !important",
      borderBottom: "1px solid #ccc !important",
      borderRadius: "0"
    }
  },
  formControl: {
    minWidth: 200
  },
  iconDrop: {
    display: "none"
  },
  mainRoot: {
    padding: "5px 14px"
  },
  menuOption: {
    "& a": {
      // color: 'red',
      textDecoration: "underline"
    }
  }
});

class HarvestYearDropDown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      SubFarmId: "",
      harvestYearLists: "",
      selectedHarvestYear: ""
    };
  }

  componentDidMount() {
    this.props.actions.getHarvestYear(
      this.props.SubFarmId || userFarmDetail().id || this.props.MainFarmId
    );
    this.props.actions.getPreferences();
  }

  componentWillReceiveProps(nextProps) {
    if (
      this.props.MainFarmId !== nextProps.MainFarmId &&
      nextProps.MainFarmId !== DropdownOptions.ALL_MAIN_FARM.id
    ) {
      this.props.actions.getHarvestYear(
        nextProps.SubFarmId || userFarmDetail().id || nextProps.MainFarmId
      );
    }

    if (
      nextProps.HarvestYearList &&
      this.props.HarvestYearList !== nextProps.HarvestYearList
    ) {
      const expectedYear =
        nextProps.HarvestYearList.filter(
          item => item.harvestYear === this.props.selectedYear
        )[0] || nextProps.HarvestYearList[0];

      localStorage.setItem(
        "selectedHarvestYear",
        JSON.stringify({
          id: expectedYear.harvestYear,
          name: expectedYear.harvestYear
        })
      );

      this.props.actions.updateHarvestYear(expectedYear.harvestYear);
    }
  }

  handleChange = event => {
    const { value } = event.target;
    console.log("History tapan", this.props.route.history, value);

    if (value === "Harvest Year Management")
      this.props.route.history.push("/harvestYearList");
    else {
      const currentPreference = this.props.PrefencesList;
      localStorage.setItem(
        "selectedHarvestYear",
        JSON.stringify({
          id: value,
          name: value
        })
      );
      currentPreference["harvestYear"] = value;

      if (!isSuperAdmin()) {
        this.props.actions.putPreferences(currentPreference);
      }
      if (this.props.selectedYear !== value)
        this.props.actions.updateHarvestYear(value);
    }
  };

  render() {
    const {
      classes,
      route: { match }
    } = this.props;
    const { harvestYearLists, selectedHarvestYear } = this.state;
    const { HarvestYearList = [], selectedYear } = this.props;
    const isDisabled =
      match &&
      (match.path === "/harvestYearList" ||
        match.path === "/app/createticket" ||
        match.path === "/app/editTicket" ||
        match.path === "/app/createcontract" ||
        match.path === "/app/editcontract" ||
        match.url === "/settings/mandatory-fields" ||
        match.path === "/farm-utilities" ||
        match.path === "/farmsetup/farminformation/field-groups/create" ||
        match.path === "/farmsetup/farminformation/field-groups/edit" ||
        match.path === "/farmsetup/trucklines/create" ||
        match.path === "/farmsetup/trucklines/edit" ||
        match.path === "/farmsetup/destinations/internal/create" ||
        match.path === "/farmsetup/destinations/internal/edit" ||
        match.path === "/farmsetup/destinations/external/create" ||
        match.path === "/farmsetup/destinations/external/edit" ||
        match.path === "/farmsetup/counterparties/create" ||
        match.path === "/farmsetup/counterparties/edit" ||
        match.path ===
          "/farmsetup/farminformation/commodity-varieties/create" ||
        match.path === "/farmsetup/farminformation/commodity-varieties/edit" ||
        match.path ===
          "/farmsetup/farminformation/field-groups/fields/create" ||
        match.path === "/farmsetup/farminformation/field-groups/fields/edit" ||
        match.path ===
          "/farmsetup/farminformation/field-groups/indicators/create" ||
        match.path ===
          "/farmsetup/farminformation/field-groups/indicators/edit" ||
        match.path === "/farmsetup/farminformation/field-groups/fields" ||
        match.path === "/farmsetup/farminformation/field-groups/indicators" ||
        match.url === "/userManagement/edit" ||
        match.url === "/farmmanagement/createsubfarm" ||
        match.url === "/changepassword" ||
        match.url === "/settings/mandatory-fields/contract")
        ? true
        : false;

    return (
      <FormControl variant="outlined" className={classes.formControl}>
        <Dropdown
          value={selectedYear}
          isClearable={false}
          disabled={isDisabled}
          handleChange={this.handleChange}
          options={HarvestYearList.map(item => ({
            name: item.harvestYear,
            id: item.harvestYear
          }))}
        />
      </FormControl>
    );
  }
}

HarvestYearDropDown.propTypes = {
  classes: PropTypes.object.isRequired
};
function mapStateToProps(state) {
  return {
    HarvestYearList: state.harvestYearReducer.HarvestYearList,
    selectedYear: state.harvestYearReducer.selectedYear,
    SubFarmId: state.FarmManagementReducer.SubFarmId,
    MainFarmId: state.FarmManagementReducer.MainFarmId,
    PrefencesList: state.preferencesReducer.PrefencesList
  };
}
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        getHarvestYear,
        updateHarvestYear,
        getPreferences,
        putPreferences
      },
      dispatch
    )
  };
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(HarvestYearDropDown));



// WEBPACK FOOTER //
// ./src/components/private/HarvestYear/HarvestYearDropDown.js